
export const paths = {
  'census': 'census',
  'search': 'search',
  'reports': 'reports',
  'scholarship': 'scholarship',
  'agreements': 'agreements',
  'settings': 'settings'
};
